<template>
  <ExternalList
      endpoint="/api/v2/publication-based-ad-formats"
      :endpoint-filters="{publication_based_channel_id: publicationBasedChannel.id}"
      :headlines=" [{width: 10, text: 'Name'}, {width: 10, text: 'Price'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="publicationBasedAdFormat => $router.push(getUrl(publicationBasedAdFormat))"
  >
    <template v-slot:default="{ row: publicationBasedAdFormat }">
      <td>
        <router-link :to="getUrl(publicationBasedAdFormat)">
          {{ publicationBasedAdFormat.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ publicationBasedAdFormat.attributes.price | price }}
      </td>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {ExternalList},

  props: {
    portal: {
      required: true
    },

    publicationBasedChannel: {
      required: true
    },
  },

  methods: {
    getUrl(publicationBasedAdFormat) {
      return '/portals/' + this.portal.id + '/publication-based-channels/' + this.publicationBasedChannel.id + '/ad-formats/' + publicationBasedAdFormat.id
    }
  }
}
</script>
